import React from 'react';
import {Button, Col, Divider, Form, Input, message, Modal, Row, Typography} from "antd";
import UseTranslate from "../../hooks/UseTranslate";
import {UseValidationPw} from "../../hooks/UseValidationPw";
import {LockOutlined, RetweetOutlined} from "@ant-design/icons";
import {useMutation} from "@tanstack/react-query";
import {changePasswordAPI} from "../../api/AuthAPI";

const ChangePwForm = ({ userInfo, open, setOpen }) => {
    const translate = UseTranslate();
    const { Title } = Typography;
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();

    const onClickChangePw = (value) => {
        changePwMutation.mutate({userPk: userInfo.data.userPk, ...value});
    }

    const changePwMutation = useMutation(data => changePasswordAPI(data), {
        onSuccess: () => {
            messageApi.success('Password change has been completed').then();
            setTimeout(() => {
                setOpen(false);
                form.resetFields();
            }, 1000)
        }
    })

    const onCloseModal = () => {
        setOpen(false);
        form.resetFields();
    }

    const CustomErrorMessage = ({ msg }) => {
        return <span dangerouslySetInnerHTML={{__html: msg}} />;
    }

    return (
        <>
            {contextHolder}
            <Modal open={open} onCancel={onCloseModal} maskClosable={false} footer={null}>
                <Title style={{textAlign: 'center'}} level={3}><RetweetOutlined /> {translate('changePw')}</Title>
                <Divider />
                <Form form={form} onFinish={onClickChangePw}>
                    <Row>
                        <Col span={24}>
                            <Form.Item name='password' rules={[{required: true, message: 'Please enter'}]}>
                                <Input.Password size='large' style={{height: '3rem'}} prefix={<LockOutlined />} placeholder={translate('currentPw')} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item name='newPassword' rules={[
                                {required: true, message: 'Please enter'},
                                ({getFieldValue}) => ({
                                    validator(_, value) {
                                        const valid = UseValidationPw(null, value, getFieldValue('password'));
                                        if (!value || valid.result) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(<CustomErrorMessage msg={valid.msg.join('<br />')} />);
                                    }
                                })
                            ]}>
                                <Input.Password size='large' style={{height: '3rem'}} prefix={<LockOutlined />} placeholder={translate('newPw')}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Form.Item name='confirmNewPw' rules={[
                                {required: true, message: 'Please enter'},
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Password do not match'))
                                    }
                                })
                            ]}>
                                <Input.Password size='large' style={{height: '3rem'}} prefix={<LockOutlined />} placeholder={translate('confirmNewPw')}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify='space-between' style={{marginTop: 12}}>
                        <Button block type='primary' htmlType='submit'>
                            {translate('save')}
                        </Button>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default ChangePwForm;